(function () {
  var ORDI = '(min-width: 1024px)';
  var triAFermer = false;
  var cache = {};
  var enCours = {};
  var dernierTerme = '';

  function ordinateur() {
    return window.matchMedia(ORDI).matches;
  }

  function barres() {
    return document.querySelectorAll('.cm-bf');
  }

  function fermerBloc(bloc) {
    var detail = bloc.querySelector('.filter');
    if (!detail || !detail.open) return;
    var panneau = bloc.querySelector('.disclosure__panel');
    detail.open = false;
    detail.classList.remove('is-closing');
    if (panneau) panneau.removeAttribute('style');
  }

  function fermerMenus(sauf) {
    document.querySelectorAll('.cm-bf .facets__filters > details-disclosure').forEach(function (bloc) {
      if (bloc !== sauf) fermerBloc(bloc);
    });
  }

  function recalerMenu(bloc) {
    var barre = bloc.closest('.cm-bf');
    var panneau = bloc.querySelector('.disclosure__panel');
    if (!barre || !panneau) return;
    bloc.classList.remove('cm-bf--fin');
    var largeur = Math.min(340, Math.max(260, panneau.offsetWidth || 300));
    if (bloc.getBoundingClientRect().left + largeur > barre.getBoundingClientRect().right) {
      bloc.classList.add('cm-bf--fin');
    }
  }

  function recalerTous() {
    document.querySelectorAll('.cm-bf .facets__filters > details-disclosure').forEach(recalerMenu);
  }

  document.addEventListener('click', function (evt) {
    if (!ordinateur()) return;

    var bascule = evt.target.closest('.cm-bf .facets__filters > details-disclosure .filter__toggle');
    if (bascule) {
      var bloc = bascule.closest('details-disclosure');
      recalerMenu(bloc);
      fermerMenus(bloc);
      return;
    }

    var choixTri = evt.target.closest('#filter-sort label, #filter-sort input');
    if (choixTri) {
      triAFermer = true;
      fermerBloc(choixTri.closest('details-disclosure'));
      return;
    }

    if (!evt.target.closest('.cm-bf .facets__filters > details-disclosure')) fermerMenus(null);
  });

  document.addEventListener('keydown', function (evt) {
    if (evt.key !== 'Escape') return;
    if (document.querySelector('.cm-bf__resultats:not([hidden])')) {
      cacherResultats();
      return;
    }
    fermerMenus(null);
  });

  window.addEventListener('resize', function () {
    if (ordinateur()) recalerTous();
  });

  function normaliser(texte) {
    return (texte || '')
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function prix(valeur) {
    var nombre = parseFloat(valeur);
    if (isNaN(nombre)) return '';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR'
      }).format(nombre);
    } catch (e) {
      return nombre.toFixed(2).replace('.', ',') + ' €';
    }
  }

  function charger(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    if (enCours[handle]) return enCours[handle];

    var produits = [];
    function page(numero) {
      return fetch('/collections/' + handle + '/products.json?limit=250&page=' + numero, {
        headers: { Accept: 'application/json' }
      })
        .then(function (reponse) {
          if (!reponse.ok) throw new Error('reponse ' + reponse.status);
          return reponse.json();
        })
        .then(function (donnees) {
          var lot = (donnees && donnees.products) || [];
          lot.forEach(function (produit) {
            var variante = (produit.variants && produit.variants[0]) || {};
            var image = (produit.images && produit.images[0] && produit.images[0].src) || '';
            produits.push({
              titre: produit.title,
              lien: '/products/' + produit.handle,
              image: image ? image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '',
              prix: prix(variante.price),
              recherche: normaliser(
                [produit.title, produit.vendor, produit.product_type, (produit.tags || []).join(' ')].join(' ')
              )
            });
          });
          if (lot.length === 250 && numero < 4) return page(numero + 1);
          cache[handle] = produits;
          return produits;
        });
    }

    enCours[handle] = page(1).catch(function () {
      cache[handle] = [];
      return [];
    });
    return enCours[handle];
  }

  function cacherResultats() {
    document.querySelectorAll('.cm-bf__resultats').forEach(function (boite) {
      boite.hidden = true;
      boite.innerHTML = '';
    });
  }

  function echapper(texte) {
    return (texte || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function afficher(boite, produits, terme) {
    if (!produits.length) {
      boite.innerHTML =
        '<p class="cm-bf__message">Aucun produit de cette collection ne correspond à « ' +
        echapper(terme) +
        ' ».</p>';
      boite.hidden = false;
      return;
    }

    boite.innerHTML = produits
      .slice(0, 8)
      .map(function (produit) {
        return (
          '<a class="cm-bf__resultat" href="' + produit.lien + '">' +
          (produit.image
            ? '<img src="' + produit.image + '" alt="" loading="lazy" width="44" height="44">'
            : '<span class="cm-bf__resultat-vide" aria-hidden="true"></span>') +
          '<span class="cm-bf__resultat-texte">' +
          '<span class="cm-bf__resultat-titre">' + echapper(produit.titre) + '</span>' +
          (produit.prix ? '<span class="cm-bf__resultat-prix">' + produit.prix + '</span>' : '') +
          '</span></a>'
        );
      })
      .join('');
    boite.hidden = false;
  }

  function chercher(champ) {
    var forme = champ.closest('.cm-bf__recherche');
    var boite = forme && forme.querySelector('.cm-bf__resultats');
    if (!boite) return;

    var terme = champ.value.trim();
    forme.classList.toggle('is-remplie', terme.length > 0);
    dernierTerme = terme;

    if (terme.length < 2) {
      boite.hidden = true;
      boite.innerHTML = '';
      return;
    }

    var handle = forme.getAttribute('data-collection');
    boite.innerHTML = '<p class="cm-bf__message">Recherche…</p>';
    boite.hidden = false;

    charger(handle).then(function (produits) {
      if (dernierTerme !== terme) return;
      var mots = normaliser(terme).split(/\s+/).filter(Boolean);
      var trouves = produits.filter(function (produit) {
        return mots.every(function (mot) {
          return produit.recherche.indexOf(mot) !== -1;
        });
      });
      afficher(boite, trouves, terme);
    });
  }

  var minuteur = null;
  document.addEventListener('input', function (evt) {
    if (!evt.target.classList || !evt.target.classList.contains('cm-bf__champ')) return;
    clearTimeout(minuteur);
    var champ = evt.target;
    minuteur = setTimeout(function () {
      chercher(champ);
    }, 180);
  });

  document.addEventListener('click', function (evt) {
    var vider = evt.target.closest('.cm-bf__vider');
    if (vider) {
      evt.preventDefault();
      var champ = vider.closest('.cm-bf__recherche').querySelector('.cm-bf__champ');
      champ.value = '';
      chercher(champ);
      champ.focus();
      return;
    }
    if (!evt.target.closest('.cm-bf__recherche')) cacherResultats();
  });

  document.addEventListener('focusin', function (evt) {
    if (evt.target.classList && evt.target.classList.contains('cm-bf__champ')) {
      var handle = evt.target.closest('.cm-bf__recherche').getAttribute('data-collection');
      if (handle) charger(handle);
      if (evt.target.value.trim().length >= 2) chercher(evt.target);
    }
  });

  function bullesMobiles() {
    barres().forEach(function (barre) {
      var source = barre.querySelector('.facets__active-filters .active-filters');
      var infos = barre.querySelector('.cm-bf__infos');
      if (!source || !infos) return;

      var zone = barre.querySelector('.cm-bf__actifs');
      if (!zone) {
        zone = document.createElement('div');
        zone.className = 'cm-bf__actifs';
        infos.parentNode.insertBefore(zone, infos);
      }

      zone.innerHTML = '';
      if (ordinateur() || source.children.length === 0) {
        zone.hidden = true;
        return;
      }
      zone.hidden = false;
      Array.prototype.forEach.call(source.children, function (lien) {
        zone.appendChild(lien.cloneNode(true));
      });
    });
  }

  window.addEventListener('resize', bullesMobiles);

  function initialiser() {
    bullesMobiles();
    if (triAFermer) {
      var tri = document.querySelector('.cm-bf #filter-sort');
      if (tri) tri.open = false;
      triAFermer = false;
    }
    if (ordinateur()) recalerTous();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiser);
  } else {
    initialiser();
  }
  document.addEventListener('on:facet-filters:updated', initialiser);
})();
